<template>
  <div class="media">
    <div style="max-width: 200px" class="mr-3">
      <field :field="fields.get('image_id')" :model="model" :errors="errors" />
    </div>
    <div class="media-body">
      <field :field="fields.get('title')" :model="model" :errors="errors" />

      <div class="form-group">
        <label>
          Category
          <sup class="label-asterisk text-danger">*</sup>
        </label>
        <div>
          <tree-select
            v-model="model.category_id"
            :multiple="true"
            :options="options"
          />
        </div>
      </div>

      <fields
        :fields="fields.except('image_id', 'category_id', 'title')"
        :model="model"
        :errors="errors"
      />
      <div class="form-group">
        <button type="button" class="btn btn-primary" @click="submit">
          {{ $t("Save") }}
        </button>
        <button type="button" class="btn btn-light" @click="cancel">
          {{ $t("Cancel") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ResourceFormMixin from "../../../mixins/ResourceFormMixin.js";
import TreeMixin from "../../../mixins/TreeMixin.js";
import Proxy from "./Proxy.js";

export default {
  name: "OfferForm",

  mixins: [ResourceFormMixin, TreeMixin],

  props: {
    company: { type: Object },
  },

  mounted() {
    if (this.company) {
      Proxy.company_id = this.company.id;
    }

    this.withUiBlocker(this.loadForm(Proxy), this.$el);
  },

  methods: {
    submit() {
      this.withUiBlocker(
        this.save(Proxy).then(() => {
          this.$toast.success(this.$t("Saved successfully"));
        }),
        this.$el
      );
    },
  },
};
</script>

<style>
.vue-treeselect__control {
  background-color: #f8fcff;
  background-clip: padding-box;
  border: 1px solid #d3dee6;
  border-radius: 0.5rem;
}

.vue-treeselect__value-container {
  height: 43px;
}

.vue-treeselect__multi-value-item {
  padding: 7px 4px;
  background-color: #f0f0f0;
  border: solid 1px #d3dee6;
}

.vue-treeselect__multi-value-label {
  color: #a0aeb8;
  font-size: 14px;
}

.vue-treeselect__placeholder {
  line-height: 42px;
}
</style>
